import { wideBreakpoints } from '@r1-frontend/ui-react/components/layouts/wideContainer';

export const getMobileFirstMedia = (media: keyof typeof wideBreakpoints): string => `${parseInt(wideBreakpoints[media]) + 1}px`;
